package com.patronat.top.client.presentation.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppSearchField
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft950
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_filter_content_description
import top.clientapp.generated.resources.client_home_search_placeholder

@Composable
fun HomeSearchRow(
    value: String,
    onValueChange: (String) -> Unit,
    onFilterClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        AppSearchField(
            value = value,
            onValueChange = onValueChange,
            placeholder = stringResource(Res.string.client_home_search_placeholder),
            modifier = Modifier.weight(1f)
        )

        androidx.compose.foundation.layout.Spacer(modifier = Modifier.size(12.dp))

        androidx.compose.foundation.layout.Box(
            modifier = Modifier
                .size(48.dp)
                .clip(RoundedCornerShape(8.dp))
                .background(MineShaft50)
                .clickable(onClick = onFilterClick),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = AppIcons.FilterSliders,
                contentDescription = stringResource(Res.string.client_home_filter_content_description),
                tint = MineShaft950,
                modifier = Modifier.size(22.dp)
            )
        }
    }
}
